import { action, thunk, thunkOn } from "easy-peasy";
import {
  makeAuthorizedPatchRequestToBackend,
  makeAuthorizedPostRequestToBackend,
  makeUrl,
} from "../helpers/backendApi";

const modelTripNotes = {
  INITIAL_DATA_ENDPOINT: "trip_notes",
  INCLUDE_APP_MODE_IN_INITIALDATA_REQUEST: false,
  INCLUDE_ITIN_MODE_IN_INITIALDATA_REQUEST: false,
  NAME: "tripNotes",
  initialData: {},
  initialDataReceived: false,
  initialDataLoading: false,
  /////////////
  // ACTIONS //
  /////////////
  resetData: action((state) => {
    state.initialData = {};
    state.initialDataReceived = false;
    state.initialDataLoading = false;
  }),
  onLogout: thunkOn(
    (__, { me, misc }) => [me.resetData],
    (actions) => {
      actions.resetData();
    }
  ),
  receiveInitialData: action((state, payload) => {
    state.initialData = Object.fromEntries(
      payload.map((tripNote) => [tripNote.trip_id, tripNote])
    );
  }),
  handleSubmitTripNote: thunk(async (actions, tripNote) => {
    const alreadyExists = !!tripNote.id;
    const endpoint = alreadyExists ? `trip_notes/${tripNote.id}` : "trip_notes";
    const url = makeUrl({ endpoint });
    const data = alreadyExists
      ? { note_contents: tripNote.note_contents }
      : { trip_id: tripNote.trip_id, note_contents: tripNote.note_contents };
    const doRequest = alreadyExists
      ? makeAuthorizedPatchRequestToBackend
      : makeAuthorizedPostRequestToBackend;
    await doRequest({
      url,
      data,
      axiosConfig: undefined,
    });
    actions.handleFetchInitialData();
  }),
};

export default modelTripNotes;
